import { AxiosPost } from "../AxiosWrapper";
import { DOCUMENTSTORE_SERVICE_URL } from "../../constants/ServiceUrls";

export const getDocument = (documentIdentifier, config, cb) => {
  return AxiosPost(
    `${DOCUMENTSTORE_SERVICE_URL}api/Metadata/GetDocumentMetadata`,
    {
      documentIdentifier: documentIdentifier,
    },
    config
  );
};

export const upsertDocumentMetadata = (data) => {
  return AxiosPost(
    `${DOCUMENTSTORE_SERVICE_URL}api/Metadata/UpsertDocumentMetadata`,
    data
  );
};
export default { getDocument, upsertDocumentMetadata };
